import React from 'react'
import { Divider, Menu, MenuItem } from '@linagora/twake-mui'
import { useI18n } from 'twake-i18n'

interface BookingLinkDesktopMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  onDelete: () => void
  onEdit: () => void
  onToggleVisibility?: () => void
  isVisible?: boolean
}

export const BookingLinkDesktopMenu: React.FC<BookingLinkDesktopMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onDelete,
  onEdit,
  onToggleVisibility,
  isVisible
}) => {
  const { t } = useI18n()

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {onToggleVisibility !== undefined && (
        <MenuItem
          onClick={() => {
            onToggleVisibility()
            onClose()
          }}
        >
          {isVisible ? t('actions.hide') : t('actions.show')}
        </MenuItem>
      )}
      {onToggleVisibility !== undefined && <Divider />}
      <MenuItem
        onClick={() => {
          onEdit()
          onClose()
        }}
      >
        {t('actions.modify')}
      </MenuItem>
      <MenuItem
        onClick={() => {
          onDelete()
          onClose()
        }}
      >
        {t('actions.delete')}
      </MenuItem>
    </Menu>
  )
}
